import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import moment from 'moment';

@Component({
  name: 'bpc-display-field-date-range',
  components: {},
})
export default class DisplayFieldDateRange extends mixins(AbstractDisplayField) {
  get formatDateRange(): string {
    const dates = [];
    if (this.item.start_date) {
      dates.push(moment(String(this.item.start_date)).format('DD/MM/YYYY'));
    }
    if (this.item.end_date && this.item.end_date != this.item.start_date) {
      dates.push(moment(String(this.item.end_date)).format('DD/MM/YYYY'));
    }
    return dates.join(' - ');
  }
}
